<template>
  <div
    v-if="!isMobile"
    class="flex-container relative d-flex flex-column ai-center"
  >
    <one-stop />

    <div class="flex-container d-flex flex-column ai-center bg-dark">
      <div class="section-wrapper d-flex flex-column jc-start mg-50 ai-center">
        <div class="mg-150" />
        <div class="flex-container d-flex jc-around ai-center color-white">
          <div class="block-item">
            <v-img :height="80" :width="80" contain :src="dmLogo"> </v-img>
            <div class="text-1 color-white mg-50 text-center">
              데이터 가공 및 수집
              <br />
              <b class="text-lg">7천만원</b>
            </div>
          </div>
          <div class="text-2xl">-</div>
          <div class="block-item">
            <v-img :height="80" :width="80" contain :src="government"> </v-img>
            <div class="text-1 color-white mg-50 text-center">
              정부지원금
              <br />
              <b class="text-lg">7천만원</b>
            </div>
          </div>
          <div class="text-2xl">=</div>
          <div class="block-item">
            <v-img :height="80" :width="80" contain :src="company"> </v-img>
            <div class="text-1 color-white mg-50 text-center">
              기업부담금
              <br />
              <b class="text-lg">0원</b>
            </div>
          </div>
        </div>
        <div
          class="flex-container d-flex ai-center jc-center mg-150 color-white"
        >
          <v-img
            class="mr-5"
            contain
            :height="50"
            :max-width="50"
            :src="quote"
          />
          <div class="text-center text-lg">
            이미 많은 기업이 <b>데이터몬스터즈</b>와 함께하고 있습니다.<br />
            7천만원을 지원받고 데이터 가공의 부담을 줄여보세요!
          </div>
          <v-img
            class="rotate-180 ml-5"
            contain
            :height="50"
            :max-width="50"
            :src="quote"
          />
        </div>
        <div class="mg-150"></div>
        <div
          class="flex-container d-flex ai-center jc-end mg-150 color-white opaque"
        >
          <div>
            ※ 정부 지원금 80% 기업 부담금 20%<br />
            ※ 모든 기업 부담금은 인건비 같은 현물로 부담 가능
          </div>
        </div>
        <div class="mg-50"></div>
      </div>
    </div>

    <voucher-roadmap />
    <voucher-examples />

    <div class="flex-container d-flex flex-column ai-center">
      <div class="flex-container flex-column ai-center bg-dark">
        <div class="mg-150" />
        <div class="section-wrapper d-flex flex-column ai-center">
          <div class="header-2 kor color-white">
            데이터몬스터즈와 함께 지원해야하는 이유
          </div>
          <div class="mg-150" />
          <div class="flex-container d-flex flex-wrap jc-around">
            <div class="reason-box color-white">
              <div class="text-xl reason-box-header">
                <b class="header-2 kor mr-2">01</b>고학력 다경험의 전문 컨설턴트
              </div>
              <div class="flex-container flex-column mt-5">
                <ul class="">
                  <li>
                    KAIST, 연세대, 토쿄대학교 석박사 출신 연구원들과<br />
                    경력 30년 이상의 전직 대학교수 등 고학력/다경험의<br />
                    연구인력 구성
                  </li>
                  <li>R Cookbook 외 4권 베스트셀러 저자/KAIST등 대학 출강</li>
                  <li>SNS, 뉴스, 커뮤니티 등 여론분석 전문가 구성</li>
                </ul>
              </div>
            </div>
            <div class="reason-box color-white">
              <div class="text-xl reason-box-header">
                <b class="header-2 kor mr-2">02</b>다양한 기술 개발 솔루션 보유
              </div>
              <div class="flex-container flex-column mt-5">
                <ul class="">
                  <li>애널리틱스 전무가를 통한 다양한 분석 솔루션</li>
                  <li>수치예측 모델링 전문가를 통한 AI 기반 예측 모델링</li>
                  <li>정보검색/자연어처리 전문가를 통한 분석 처리 기술</li>
                  <li>텍스트 마이닝 전문가를 통한 고품질의 정보 확보</li>
                  <li>센서 데이터 전문가를 통한 데이터 통합 및 예측 추론</li>
                  <li>
                    딥러닝 및 이미지 처리 전문가를 통한 고객 맞춤형 서비스
                  </li>
                </ul>
              </div>
            </div>
            <div class="reason-box color-white">
              <div class="text-xl reason-box-header">
                <b class="header-2 kor mr-2">03</b>다양한 데이터가공 지원 실적
              </div>
              <div class="flex-container flex-column mt-5">
                <ul class="">
                  <li>AI/데이터바우처 사업 실적 15건</li>
                  <li>데이터바우처 유사 실적 10건</li>
                  <li>{{ "R&D 사업 지원 4건" }}</li>
                  <li>B2B 사업 지원 5건</li>
                  <li>
                    <div class="flex-container d-flex jc-between">
                      공공 사업 지원 4건

                      <router-link
                        class="color-white text-underline"
                        to="/insights"
                      >
                        Learn More
                      </router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="reason-box color-white">
              <div class="reason-box-header text-xl whitespace-nowrap">
                <b class="header-2 kor mr-2">04</b>
                <span>지원사업 초보자 맞춤형 서비스</span>
              </div>
              <div class="flex-container flex-column mt-5">
                <ul class="">
                  <li>
                    다수의 지원 사업 경험을 통한 서류 작성에 일정<br />
                    확인까지 원스톱 지원
                  </li>
                  <li>기업 니즈 맞춤형 기술개발 솔루션 제공</li>
                  <li>최적화된 Work flow를 통한 데이터 검증 및 보수</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="mg-150" />
      </div>

      <div
        class="section-wrapper relative d-flex flex-column jc-start ai-center voucher-process"
      >
        <div class="flex-container flex-column mg-150 ai-center">
          <div class="header-2 kor">데이터몬스터즈 업력</div>

          <div class="flex-container ai-center text-center text-lg mg-100">
            <v-img
              class="mr-auto"
              max-height="500px"
              max-width="500px"
              contain
              :src="history"
            />
            <span
              >데이터 공급 및 가공기업으로 <b>3년째 공급 지원 중</b>,<br />
              약 <b>20개 기업</b>에 솔루션 제공 이력!<br />
              데이터 종류별 다양한 경험과 기술 개발 분야의 전문인력 보유!</span
            >
          </div>
        </div>

        <div class="header-2 kor mg-150">
          데이터바우처 지원사업 및 유사 실적
        </div>
        <div class="flex-container d-flex mg-150">
          <ul class="text-lg">
            <li>빅데이터 수집/분석 및 <br />기계학습 기반 모델링 5건 등</li>
            <li>인터랙티브 웹 대시보드 구축 7건 등</li>
            <li>예측/추천/분석 시스템 개발 4건 등</li>
            <li>텍스트데이터 활용 사전 구축 3건 등</li>
            <li>AI 기반 모델링 3건 등</li>
            <li>
              스마트팩토리/뷰티/의류/부동산/<br />수산물/유통/물류/자연 에너지
              등의<br />
              <span class="text-underline"> 다양한 산업군별 데이터 가공 </span>
              <br /><br /><br />
              <router-link to="/insights">
                <v-btn outlined color="#1c1c1c">Learn more</v-btn>
              </router-link>
            </li>
          </ul>
          <v-img
            class="ml-auto"
            max-height="500px"
            max-width="500px"
            contain
            :src="performance"
          />
        </div>
        <div class="mg-150" />
      </div>

      <div class="flex-container flex-column ai-center bg-dark">
        <div class="section-wrapper flex-column ai-center mg-150 color-white">
          <div class="header-2 kor">데이터바우처 FAQ</div>
          <div class="mg-150" />
          <div class="faq-question flex-container ai-end text-xl">
            <b class="text-2xl mr-5">Q</b> 데이터에 대한 전문 지식이 부족한데
            참여할 수 있을까요?
          </div>
          <div class="flex-container text-lg">
            <b class="text-2xl mr-5">A</b>
            <div class="pt-3 ml-2">
              <b>네! 가능합니다.</b> 데이터몬스터즈의 전문 인력을 통해 기업의
              니즈에 맞는 맞춤형 기술개발 솔루션<br />을 확인하실 수 있습니다!
            </div>
          </div>
          <div class="mg-50" />
          <div class="faq-question flex-container ai-end text-xl">
            <b class="text-2xl mr-5">Q</b> 전체적인 플랫폼 구축 혹은 부분적인
            가공도 해주시나요?
          </div>
          <div class="flex-container text-lg">
            <b class="text-2xl mr-5">A</b>
            <div class="pt-3 ml-2">
              <b>네! 두 가지 모두 가능합니다.</b> 부분적인 가공부터 전체 플랫폼
              구축까지 요구사항에 맞는 컨설팅을 <br />해드립니다. 단, 사업범위가
              넓어지면 개발비가 추가될 수 있습니다.
            </div>
          </div>
          <div class="mg-50" />
          <div class="faq-question flex-container ai-end text-xl">
            <b class="text-2xl mr-5">Q</b> 사용할 수 있는 데이터의 보유 유무를
            몰라 <br />비즈니스 아이디어를 제대로 활용할 수 있을지 걱정입니다.
          </div>
          <div class="flex-container text-lg">
            <b class="text-2xl mr-5">A</b>
            <div class="pt-3 ml-2">
              <b>걱정하지 마세요!</b> 상담을 통해 접근 가능한 자료원과 활용 가능
              데이터 목록부터 점검해 드립니다.
            </div>
          </div>
          <div class="mg-150" />
          <router-link to="/datavoucher/inquiry">
            <v-btn x-large width="500" outlined color="white"
              ><b>사업문의 하러가기</b></v-btn
            >
          </router-link>
          <div class="mg-150" />
        </div>
      </div>
    </div>

    <voucher-applicant />
    <voucher-process />
  </div>
  <div class="flex-container" v-else>
    <div class="mobile-top-nav header-2">Data Voucher</div>
    <div class="mg-55" />
    <div class="voucher-content">
      <router-link
        to="/datavoucher/inquiry"
        class="vocher-content-action-link link-1"
      />
      <router-link
        to="/datavoucher/inquiry"
        class="vocher-content-action-link link-2"
      />
      <router-link
        to="/datavoucher/inquiry"
        class="vocher-content-action-link link-3"
      />
      <router-link to="/insights" class="vocher-content-action-link link-4" />
      <router-link to="/insights" class="vocher-content-action-link link-5" />
      <router-link to="/insights" class="vocher-content-action-link link-6" />
    </div>
  </div>
</template>

<script>
import dmLogo from "@/assets/dmlogo.png";
import quote from "@/assets/quote.svg";
import arrow from "@/assets/arrow.svg";
import graph from "@/assets/graph.svg";
import government from "@/assets/government.svg";
import company from "@/assets/company.svg";
import question from "@/assets/question.svg";
import time from "@/assets/time.svg";
import trend from "@/assets/trend.svg";
import professional from "@/assets/professional.svg";
import understanding from "@/assets/understanding.svg";
import track from "@/assets/track.svg";
import develop from "@/assets/develop.svg";
import solution from "@/assets/solution.svg";
import efficiency from "@/assets/efficiency.svg";
import insight from "@/assets/insight.svg";
import monitoring from "@/assets/monitoring.svg";
import performance from "@/assets/performance.jpg";
import history from "@/assets/history.jpg";

import OneStop from "../components/OneStop.vue";
import VoucherRoadmap from "../components/VoucherRoadmap.vue";
import VoucherApplicant from "../components/VoucherApplicant.vue";
import VoucherProcess from "../components/VoucherProcess.vue";
import VoucherExamples from "../components/VoucherExamples.vue";

export default {
  name: "DataVoucher",
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  data: () => ({
    dmLogo: dmLogo,
    quote: quote,
    arrow: arrow,
    graph: graph,
    government: government,
    company: company,
    question: question,
    time: time,
    trend: trend,
    professional: professional,
    understanding: understanding,
    track: track,
    develop: develop,
    solution: solution,
    efficiency: efficiency,
    insight: insight,
    monitoring: monitoring,
    performance: performance,
    history: history,
  }),
  components: {
    OneStop,
    VoucherRoadmap,
    VoucherProcess,
    VoucherApplicant,
    VoucherExamples,
  },
};
</script>

<style>
.jc-center {
  justify-content: center;
}

.ai-end {
  align-items: flex-end;
}

.text-lg {
  font-size: 21px;
}

.text-xl {
  font-size: 27px;
}

.text-center {
  text-align: center;
}

.text-underline {
  text-decoration: underline;
}

.jc-between {
  justify-content: space-between;
}

.block-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.jc-start {
  justify-content: flex-start;
}

.jc-end {
  justify-content: flex-end;
}

.jc-around {
  justify-content: space-around;
}

.text-2xl {
  font-size: 50px;
}

.rotate-180 {
  transform: rotate(180deg);
}

.outline-box {
  border: 3px solid white;
  width: 100%;
  position: relative;
  display: flex;
  padding: 60px 35px;
}

.outline-box-header {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 25px;
  border: 3px solid white;
}

.arrow-down {
  transform: rotate(90deg);

  margin: 50px 0;
}

.applicant-box {
  width: 350px;
  border: 5px solid #cde9ff;
  border-radius: 10px;
  margin: 10px;
  text-align: center;
  padding: 50px 0px;
}

.applicant-box-header {
  padding: 10px;
  font-size: 21px;
  font-weight: 500;
  border-bottom: 3px solid white;
}

.flex-wrap {
  flex-wrap: wrap;
}

.h-full {
  height: 200px;
}

.light {
  background-color: white;
  border-color: #1c1c1c;
}

.progress-item {
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 3px solid white;
}

.reason-box {
  width: 400px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reason-box-header {
  padding-bottom: 3px;
  border-bottom: 3px solid white;
  width: 100%;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.faq-question {
  padding-bottom: 10px;
  border-bottom: 2px solid #ffffff88;
}

.voucher-content {
  background: url("../assets/voucher_content.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center 55px;
  width: 100%;
  height: 800vw;
  position: relative;
}

.vocher-content-action-link {
  position: absolute;
}

.link-1 {
  top: 78vw;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height: 50px;
}

.link-2 {
  top: 443vw;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height: 50px;
}

.link-3 {
  top: 773vw;
  right: 5vw;
  width: 30%;
  height: 50px;
}

.link-4 {
  top: 540vw;
  left: 15vw;
  width: 35%;
  height: 40px;
}

.link-5 {
  top: 617vw;
  left: 20vw;
  width: 35%;
  height: 40px;
}

.link-6 {
  top: 655vw;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 50vw;
}
</style>